import { h } from 'preact';
import classNames from 'classnames';
import ColorSwatch from './ColorSwatch';
import PillOption from './PillOption';

const ProductOptionRow = ({
  option,
  fitText,
  formOptions,
  position,
  productId,
  setFormOptions,
  sectionId,
  productVariants,
  sizeGuide,
  hideSizeGuide,
  classes,
  initialChange,
}) => {
  const openSizeGuide = () => {
    const body = document.querySelector('body');
    const sizeGuideTarget = document.querySelector(
      `[data-size-guide="${sizeGuide}"]`,
    );
    sizeGuideTarget.classList.add('open-sizeguide');
    body.classList.add('overflow-hidden');
  };
  return (
    <div>
      <label
        className={classNames(
          'body-2',
          'flex',
          'gap-4',
          option.name === 'Color' ? 'hidden' : 'mb-10',
        )}
        htmlFor={option.name}
      >
        {option.name}:
        <span className="body-2 text-subdued">{formOptions.option_2}</span>
        <span className="body-2 text-gray-800">
          {formOptions[position]}
          {fitText ? (
            <span className="body-3 -mt-4 ml-8 rounded-5 bg-gray-400 px-8 py-2 text-gray-900 lg:ml-10">
              {fitText}
            </span>
          ) : null}
        </span>
        {sizeGuide && hideSizeGuide === false ? (
          <button
            type="button"
            data-target="open-sizeguide"
            data-size-guide-handle={sizeGuide}
            className="body-3 ml-auto underline"
            onClick={openSizeGuide}
          >
            Size Guide
          </button>
        ) : null}
      </label>
      <div
        className={classNames(
          classes,
          option.name === 'Color'
            ? 'group flex flex-wrap items-center gap-8 py-4'
            : 'grid grid-cols-3 gap-16 md:grid-cols-6 md:gap-6',
        )}
      >
        {option.values.map((value, index) => {
          const radioId = `option-${sectionId}-${productId}-${
            option.name
          }-${value.replace(/[^a-zA-Z0-9-_]/g, '')}`;

          let available = true;

          // if (option.name === 'Size') {
          const foundVariant = productVariants.find(
            (variant) =>
              (variant.option1 === formOptions.option_1 &&
                variant.option2 === value) ||
              (variant.option2 === formOptions.option_2 &&
                variant.option1 === value),
          );

          available = foundVariant?.available;
          // }

          const colorOption = option.name === 'Color' ? value : '';
          const colorVariants = productVariants.filter((variant) =>
            variant.options.includes(colorOption),
          );
          const soldOutVariants = colorVariants.filter(
            (variant) => !variant.available,
          );
          const soldOut = colorVariants.length === soldOutVariants.length;

          return (
            <label
              key={index}
              htmlFor={radioId}
              className={classNames('cursor-pointer')}
            >
              <input
                {...(!available && { 'data-unavailable': true })}
                type="radio"
                name={`option_${option.position}`}
                defaultValue={value}
                id={radioId}
                className="peer hidden"
                checked={value === formOptions[`option_${option.position}`]}
                onChange={(event) =>
                  setFormOptions((prevFormOptions) => ({
                    ...prevFormOptions,
                    [`option_${option.position}`]: event.target.value,
                  }))
                }
              />

              {option.name === 'Color' ? (
                <ColorSwatch
                  value={value}
                  soldOut={soldOut}
                  available={available}
                  initialChange={initialChange}
                />
              ) : (
                <PillOption value={value} />
              )}
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default ProductOptionRow;
